import React, { Fragment } from "react";
import View from "./view/View";
import Input from "./input/Input";

const Body = ( props ) => {

  const { Inputer } = props;

  return (
    <div className="container">
      <div className="inner">
        <div className="learningBox">
          <View />
          <Inputer><Input /></Inputer>
        </div>
      </div>
    </div>
  );

};

Body.defaultProps = {
  Inputer : Fragment
};

export default Body;
